import { useEffect, useRef } from "react";

/**
 * Hook providing access to the value of a provided argument in the previous
 * render.
 *
 * @param value Value to store and return on the next render.
 * @returns The value of the provided argument in the previous render or
 *   `undefined` during the first render.
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  // eslint-disable-next-line react-hooks/refs
  return ref.current;
}
